import React, { useMemo, useState } from 'react';
import { Select, Checkbox, Divider } from 'antd';
import '../CSS/style-guide.css';

const { Option } = Select;

const MultiSelect = ({
  options = [],
  value = [],
  onChange,
  placeholder = 'Select',
  disabled = '',
  maxTagTextLength = 20,
  maxTagCount = 1,
}) => {
  const [searchValue, setSearchValue] = useState('');

  const dropdownStyle = useMemo(() => {
    if (placeholder === 'Select Categories') {
      return { width: 800 };
    } else if (placeholder === 'Select Signing Legal Entity') {
      return { width: 400 };
    } else if (placeholder === 'Select Supplier') {
      return { width: 350 };
    } else if (placeholder === 'Select Scope') {
      return { width: 300 };
    } else if (placeholder === 'Select Standard Clauses') {
      return { width: 250 };
    } else if (placeholder === 'Select Contract Type') {
      return { width: 320 };
    }
    return {};
  }, [placeholder]);

  // Normalize options to { value, label } format
  const normalizedOptions = useMemo(() => {
    if (!Array.isArray(options)) return [];
    return options.map(opt =>
      typeof opt === 'string' ? { value: opt, label: opt } : opt
    );
  }, [options]);

  const filteredOptions = useMemo(() => {
    const filtered = normalizedOptions.filter((item) =>
      item.label.toLowerCase().includes(searchValue.toLowerCase())
    );
    const selectedSet = new Set(value);
    return filtered.sort((a, b) => {
      const aSelected = selectedSet.has(a.value);
      const bSelected = selectedSet.has(b.value);
      return aSelected === bSelected
        ? a.label.localeCompare(b.label)
        : aSelected ? -1 : 1;
    });
  }, [searchValue, normalizedOptions, value]);

  const checkAll = value.length === filteredOptions.length;
  const indeterminate = value.length > 0 && value.length < filteredOptions.length;

  const handleChange = (val) => {
    if (val.includes('__all__')) {
      const newValue = checkAll ? [] : filteredOptions.map(opt => opt.value);
      onChange(newValue);
    } else {
      onChange(val);
    }
  };

  return (
    <Select
      className='select'
      mode="multiple"
      showSearch
      dropdownStyle={dropdownStyle}
      filterOption={false}
      onSearch={setSearchValue}
      onDropdownVisibleChange={(open) => {
        if (!open) setSearchValue('');
      }}
      value={value}
      onChange={handleChange}
      placeholder={placeholder}
      disabled={disabled}
      maxTagTextLength={maxTagTextLength}
      maxTagCount={maxTagCount}
      style={{ minWidth: '200px' }}
      onKeyDown={(e) => {
        if (e.key === 'Tab' || e.key === 'Enter') {
          e.preventDefault();
          e.target.blur();
        }
      }}
      dropdownRender={(menu) => (
        <>
          <div style={{ padding: '8px 12px' }}>
            <Checkbox
              indeterminate={indeterminate}
              onChange={() => {
                const newValue = checkAll ? [] : filteredOptions.map(opt => opt.value);
                onChange(newValue);
              }}
              checked={checkAll}
            >
              Select All
            </Checkbox>
          </div>
          <Divider style={{ margin: '4px 0' }} />
          {menu}
        </>
      )}
    >
      {filteredOptions.map((item) => (
        <Option key={item.value} value={item.value}>
          {item.label}
        </Option>
      ))}
    </Select>
  );
};

export default MultiSelect;